/**
 * The yellow window of "Part of the clip" (design b1): where the used part sits on the whole
 * footage, in percent, and the latest start that still fits. With an unknown length the window
 * fills the bar. Pure.
 */
export function trimWindow(
  inSec: number,
  usedSec: number,
  totalSec: number | null
): { leftPct: number; widthPct: number; maxInSec: number } {
  if (totalSec === null || totalSec <= 0) {
    return { leftPct: 0, widthPct: 100, maxInSec: Math.max(0, inSec) };
  }
  const maxInSec = Math.max(0, totalSec - usedSec);
  const start = Math.min(Math.max(0, inSec), totalSec);
  const width = Math.min(usedSec, totalSec - start);
  return { leftPct: (start / totalSec) * 100, widthPct: (Math.max(0, width) / totalSec) * 100, maxInSec };
}
